import { HttpStatus } from '../constants';

import { ResponseError } from './ResponseError';

export class CancelError extends ResponseError {
  static readonly CANCEL = 'CANCEL';

  constructor() {
    super(HttpStatus.CLIENT_CLOSED_REQUEST, CancelError.CANCEL, 'Request cancelled', null, null);
  }
}

export const isCancelError = (error: unknown): error is CancelError => error instanceof CancelError;
